/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import AppDownloadPopUp from "./AppDownloadPopUp";

export default AppDownloadPopUp;
